import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin-left: 60px;
  position: relative;
  cursor: pointer;
  margin-right: 20px;

  @media (max-width: 1170px) {
    /* display: ${props => props.size === "deskTop" ? 'block' : 'none'}; */
    margin-left: auto;
  };
  @media (max-width: 920px) {
    margin-right: 10px;
  };

  & > div:nth-child(1) {
    position: relative;
    display: flex;
    align-items: center;
    width: 100px;
    height: 30px;
    border-radius: 30px;
    background: rgba(255, 255, 255, 0.2);
    border: none;
    z-index: 30;

    &:after {
      position: absolute;
      content: "";
      top: ${props => props.size === "deskTop" ? '9px' : '13px'};
      right: 14px;
      width: 0;
      height: 0;
      border: 4px solid transparent;
      border-color: white transparent transparent transparent;
      transform: ${props => props.size === "deskTop" ? 'rotate(180deg)' : 'rotate(0deg)'};
    }

    & > p {
      margin-left: 25px;
      font-size: 11px;
      color: white;
    }
  }
`
const PickSelectBox = styled.div`
  opacity: ${props => props.Translation ? "1" : "0"};
  z-index: ${props => props.Translation ? "50" : "0"};
  visibility: ${props => props.Translation ? "visible" : "hidden"};
  display: flex;
  position: absolute;
  top: ${props => props.size === "deskTop" ? '-115px' : '40px'};
  right: ${props => props.size === "deskTop" ? 'auto' : '0px'};
  left: ${props => props.size === "deskTop" ? '0' : 'auto'};
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 200px;
  padding: 10px 0;
  border-radius: 10px;
  background-color: white;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  transition-property: all;
  transition-duration: 0.3s, 0.1s, 0.3s;

  & > p {
    line-height: 300%;
    font-size: 13px;
    color: #222;
    cursor: pointer;
    width: 100%;
    font-weight: 600;
    text-align: center;
  }
`

const LanguageSelect = ({ style, size, language, Translation, TranslationHandler, KoreaLanguageHandler, EnglishLanguageHandler }) => {

  return (
    <Container style={style} size={size}>
      <div onClick={TranslationHandler}><p>{language}</p></div>
      <PickSelectBox Translation={Translation} size={size}>
        <p onClick={EnglishLanguageHandler}>English</p>
        <p onClick={KoreaLanguageHandler}>Korean</p>
      </PickSelectBox>
    </Container>
  );
};

export default LanguageSelect; 